import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';
import { IconName } from '@fortawesome/free-brands-svg-icons';
import { environment } from '../../environments/environment';
declare var $: any;
import { convertToNgbDate, datePickerMinDate, noWhitespaceInRequiredValidator } from '../shared/constants';
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net';
import { debounceTime, distinctUntilChanged, map, Subscription, tap } from 'rxjs';
import { isBefore } from 'date-fns';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrl: './dashboard.component.scss'
})

export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
	activeTab = 0;
	vesselDetails: any = {};
	vesselId: any = null;
	mediaURL = environment.File_Storage_URL;
	@ViewChildren(DataTableDirective) dtElements!: QueryList<DataTableDirective>;

	listMed: any[] = [];
	loadingMeds = false;
	dtOptionsMed: Config = {};
	formCtrlSubMed!: Subscription;
	searchControlMed: FormControl = new FormControl(null);

	listEquipment: any[] = [];
	loadingEquip = false;
	dtOptionsEquip: Config = {};
	formCtrlSubEquip!: Subscription;
	searchControlEquip: FormControl = new FormControl(null);

	listDispensation: any[] = [];
	loadingDisp = false;
	dtOptionsDisp: Config = {};
	formCtrlSubDisp!: Subscription;
	searchControlDisp: FormControl = new FormControl(null);

	/* searchForm!: FormGroup; */
	downloadLoader = false;
	/* lastUpdatedDateTime: any = null; */
	last_stock_date: any = null;
	vesselDetailsLoader = false;
	enableFields = true;
	minDate = datePickerMinDate;
	maxDate = convertToNgbDate(new Date());
	expiry_month = 9;
	vessels = this.apiService.getVesselsFromLocalStorage();
	maxRecipientName = 50;
	maxNotes = 200;
	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute, private location: Location, private toastr: ToastrService, private http: HttpClient) {
		/* this.searchForm = this.formBuilder.group({
			search: '',
		}); */
	}

	ngOnInit(): void {
		this.activeRoute.paramMap.pipe(map(p => p.get('vesselId')), distinctUntilChanged(), tap(uId => {
			this.vesselId = uId;
			try {
				this.vesselId = decodeURIComponent(this.vesselId);
			} catch (e) { }
			let validVessel = false;
			for (let i = 0; i < this.vessels.length; i++) {
				if (this.vesselId == this.vessels[i]) {
					validVessel = true;
				}
			}
			if (!validVessel) {
				this.apiService.navigateToLogin(false);
			} else {
				this.getVesselDetails();
				this.getListMeds();
				this.getListEquip();
				this.getListDisp();
			}
		})).subscribe();
	}

	ngOnDestroy() {
		try {
			this.formCtrlSubMed.unsubscribe();
		} catch (error) { }
		try {
			this.formCtrlSubEquip.unsubscribe();
		} catch (error) { }
		try {
			this.formCtrlSubDisp.unsubscribe();
		} catch (error) { }
	}

	ngAfterViewInit(): void {
		this.formCtrlSubMed = this.searchControlMed.valueChanges.pipe(debounceTime(500)).subscribe(newValue => {
			this.refreshTableMed();
		});
		this.formCtrlSubEquip = this.searchControlEquip.valueChanges.pipe(debounceTime(500)).subscribe(newValue => {
			this.refreshTableEquip();
		});
		this.formCtrlSubDisp = this.searchControlDisp.valueChanges.pipe(debounceTime(500)).subscribe(newValue => {
			this.refreshTableDisp();
		});
	}

	getVesselDetails() {
		this.vesselDetailsLoader = true;
		this.apiService.getVesselDetails({ start: 0, length: 1, "vessel_ids": [this.vesselId] }).subscribe({
			next: (data: any) => {
				this.vesselDetails = data.data[0];
				this.vesselDetailsLoader = false;
			}, error: (error) => {
				this.vesselDetailsLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Vessel not found", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	getListMeds() {
		this.dtOptionsMed = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			layout: {
				topStart: ['pageLength'],
				topEnd: [],
				bottomStart: ['info'],
				bottom: [],
				bottomEnd: ['paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				const data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					vessel_id: this.vesselId,
					type: "MEDS"
				}
				if (this.searchControlMed.value) {
					data["search"] = this.searchControlMed.value;
				}
				this.apiService.getVesselInventory(data).subscribe({
					next: (response: any) => {
						this.listMed = response.data;
						/* this.lastUpdatedDateTime = response.lastUpdatedDateTime; */
						this.last_stock_date = response.last_stock_date;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getListEquip() {
		this.dtOptionsEquip = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			layout: {
				topStart: ['pageLength'],
				topEnd: [],
				bottomStart: ['info'],
				bottom: [],
				bottomEnd: ['paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				const data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					vessel_id: this.vesselId,
					type: "EQUIP"
				}
				if (this.searchControlEquip.value) {
					data["search"] = this.searchControlEquip.value;
				}
				this.apiService.getVesselInventory(data).subscribe({
					next: (response: any) => {
						this.listEquipment = response.data;
						/* this.lastUpdatedDateTime = response.lastUpdatedDateTime; */
						this.last_stock_date = response.last_stock_date;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getListDisp() {
		this.dtOptionsDisp = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			layout: {
				topStart: ['pageLength'],
				topEnd: [],
				bottomStart: ['info'],
				bottom: [],
				bottomEnd: ['paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				const data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					vessel_id: this.vesselId
				}
				if (this.searchControlDisp.value) {
					data["search"] = this.searchControlDisp.value;
				}
				this.apiService.getConsumptionLogs(data).subscribe({
					next: (response: any) => {
						this.listDispensation = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	refreshTableMed() {
		this.dtElements.forEach((dtElement: DataTableDirective, index: number) => {
			dtElement.dtInstance.then((dtInstance: any) => {
				if (dtInstance.table().node().id == "medicineTable") {
					dtInstance.draw();
				}
			});
		});
	}

	refreshTableEquip() {
		this.dtElements.forEach((dtElement: DataTableDirective, index: number) => {
			dtElement.dtInstance.then((dtInstance: any) => {
				if (dtInstance.table().node().id == "equipmentTable") {
					dtInstance.draw();
				}
			});
		});
	}

	refreshTableDisp() {
		this.dtElements.forEach((dtElement: DataTableDirective, index: number) => {
			dtElement.dtInstance.then((dtInstance: any) => {
				if (dtInstance.table().node().id == "dispensationTable") {
					dtInstance.draw();
				}
			});
		});
	}

	searchFromList(index: number, type: string) {
		try {
			let list: any[] = [];
			if (type == "MEDS") {
				list = this.listMed;
			} else {
				list = this.listEquipment;
			}
			let searchTerm: any = /* this.searchForm.value.search || */ "";
			let searchMatched = false;
			if (!searchTerm) {
				searchMatched = true;
			}
			let medName: any = list[index].med_name;
			if (medName) {
				if (medName.toLowerCase().includes(searchTerm.toLowerCase())) {
					searchMatched = true;
				}
			}
			return searchMatched;
		} catch (error) {
			return true;
		}
	}

	getBackgroundColor(index: number, type: string) {
		/* let list = type == "MEDS" ? this.listMed : this.listEquipment;
		if (list[index].is_narcotic) {
			return 'narcotic';
		}
		try {
			if (list[index].med_storage == "REFRIGERATOR") {
				return 'refrigerator';
			}
			if (list[index].med_storage == "BULKY ITEM") {
				return 'bulky';
			}
		} catch (error) { } */
		return '';
	}

	downloadInventoryOld() {
		this.downloadLoader = true;
		const payload: any = { "vessel_id": this.vesselId };
		this.apiService.vesselInventryExcelDownload(payload).subscribe({
			next: (res: any) => {
				let excelData: any = atob(res.body);
				this.downloadLoader = false;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = "Vessel Inventory" + "-" + moment().format("DD-MM-YYYY HH_mm_ss") + ".xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.downloadLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	downloadInventory() {
		this.downloadLoader = true;
		const payload: any = { "vessel_id": this.vesselId };
		this.apiService.vesselInventryExcelDownload(payload).subscribe({
			next: (res: any) => {
				this.downloadLoader = false;
				const byteCharacters = atob(res.body);
				const byteArrays: any[] = [];

				for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
					const slice = byteCharacters.slice(offset, offset + 1024);
					const byteNumbers = new Array(slice.length);
					for (let i = 0; i < slice.length; i++) {
						byteNumbers[i] = slice.charCodeAt(i);
					}
					byteArrays.push(new Uint8Array(byteNumbers));
				}
				const blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const link = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				link.href = url;
				let fileName = "Vessel Inventory" + "-" + moment().format("DD-MM-YYYY HH_mm_ss") + ".xlsx";
				link.download = fileName;
				link.click();
				window.URL.revokeObjectURL(url);
			}, error: (error) => {
				this.downloadLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});

	}

	getTabClass(tabNum: number) {
		if (this.activeTab == tabNum) {
			return "active";
		} else {
			return "";
		}
	}

	setActiveTab(tabNum: number) {
		this.activeTab = tabNum;
		if (tabNum == 0) {
		} else if (tabNum == 1) {
		}
	}

	getTabPaneClass(tabNum: any) {
		if (this.activeTab == tabNum) {
			return "active";
		} else {
			return "";
		}
	}

	clearSearchInputMed() {
		this.searchControlMed.setValue(null);
	}

	clearSearchInputEquip() {
		this.searchControlEquip.setValue(null);
	}

	clearSearchInputDisp() {
		this.searchControlDisp.setValue(null);
	}

	batchList: any[] = [];
	timeoutHandlerAdd: any;
	timeoutHandlerMinus: any;
	showBatchSaveLoader: any = null;
	showBatchLoader: any = null;
	boxMed: any = null;
	getStyle(index: number) {
		let styleObj: any = {};
		let changeColor = "#69ff6f";
		let unchangedColor = "#dbd9d9";
		if (this.batchList[index].batch_qty == this.batchList[index].batch_qty_original) {
			styleObj = { "border-color": unchangedColor, "border-width": "medium" };
		} else {
			styleObj = { "border-color": changeColor, "border-width": "medium" };
		}
		return styleObj;
	}

	addQty(index: number) {
		this.batchList[index].batch_qty++;
		this.batchFormChanged(index);
	}

	minusQty(index: number) {
		this.batchList[index].batch_qty--;
		this.batchFormChanged(index);
	}

	mouseupAdd() {
		if (this.timeoutHandlerAdd) {
			clearInterval(this.timeoutHandlerAdd);
			this.timeoutHandlerAdd = null;
		}
	}

	mousedownAdd(index: number) {
		this.timeoutHandlerAdd = setInterval(() => {
			this.addQty(index);
		}, 100);
	}

	mouseupMinus() {
		if (this.timeoutHandlerMinus) {
			clearInterval(this.timeoutHandlerMinus);
			this.timeoutHandlerMinus = null;
		}
	}

	mousedownMinus(index: number) {
		this.timeoutHandlerMinus = setInterval(() => {
			this.minusQty(index);
		}, 100);
	}

	medicineBrandQtyExpDetails(medicine: any) {
		this.showBatchLoader = medicine.id;
		this.apiService.MedicineBrandQtyExpList({ id: medicine.id, vessel_id: this.vesselId }).subscribe({
			next: (data: any) => {
				this.boxMed = medicine.med_name;
				this.showBatchLoader = null;
				for (let i = 0; i < data.data.length; i++) {
					data.data[i].batch_qty_original = data.data[i].batch_qty;
				}
				this.batchList = data.data;
				$("#batchDetailsModalDash").modal("show");
			}, error: (error) => {
				this.showBatchLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearBatchModal() {
		this.batchList = [];
		this.showBatchSaveLoader = null;
	}

	batchFormChanged(i: number) {
		let cons_qty: any;
		if (this.batchList[i].batch_qty_original > this.batchList[i].batch_qty) {
			cons_qty = this.batchList[i].batch_qty_original - this.batchList[i].batch_qty;
		} else {
			cons_qty = this.batchList[i].batch_qty - this.batchList[i].batch_qty_original;
		}
		this.batchList[i].cons_qty = cons_qty;
		let cons_type: any;
		if (this.batchList[i].batch_qty_original > this.batchList[i].batch_qty) {
			cons_type = "Subtract";
		} else {
			cons_type = "Add";
		}
		this.batchList[i].cons_type = cons_type;
	}

	logDispensation(i: number) {
		if (this.batchList[i].batch_qty_original == this.batchList[i].batch_qty) {
			this.toastr.error("Nothing to change", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (isNaN(this.batchList[i].batch_qty) || parseFloat(this.batchList[i].batch_qty) < 0) {
			this.toastr.error("Please enter valid quantity", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		let cons_qty: any;
		if (this.batchList[i].batch_qty_original > this.batchList[i].batch_qty) {
			cons_qty = this.batchList[i].batch_qty_original - this.batchList[i].batch_qty;
		} else {
			cons_qty = this.batchList[i].batch_qty - this.batchList[i].batch_qty_original;
		}
		let cons_type: any;
		if (this.batchList[i].batch_qty_original > this.batchList[i].batch_qty) {
			cons_type = "Subtract";
		} else {
			cons_type = "Add";
			this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		let payload: any = {
			line_id: this.batchList[i].line_id,
			batch_qty: this.batchList[i].batch_qty,
			cons_type: cons_type,
			cons_qty: cons_qty
		}
		if (cons_type == "Subtract") {
			if (!this.batchList[i].cause) {
				this.toastr.error("Please select cause", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			} else if (this.batchList[i].cause == 'med_case') {
				if (!this.batchList[i].log_date) {
					this.toastr.error("Please enter date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				}
				if (this.batchList[i].log_date && isBefore(new Date(), this.batchList[i].log_date)) {
					this.toastr.error("Please enter valid date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				}
				/* if (!this.batchList[i].rank) {
					this.toastr.error("Please enter rank", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				}
				if (!this.batchList[i].nationality) {
					this.toastr.error("Please enter nationality", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				} */
				if (!this.batchList[i].recepient_name) {
					this.toastr.error("Please enter recepient name", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				}
				payload["med_case"] = true;
				payload["is_dispose"] = false;
				payload["recepient_name"] = this.batchList[i].recepient_name || "";
				payload["rank"] = this.batchList[i].rank || "";
				payload["nationality"] = this.batchList[i].nationality || "";
				payload["stock_notes"] = this.batchList[i].stock_notes || "";
			} else if (this.batchList[i].cause == "is_dispose") {
				if (!this.batchList[i].log_date) {
					this.toastr.error("Please enter date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				}
				if (this.batchList[i].log_date && isBefore(new Date(), this.batchList[i].log_date)) {
					this.toastr.error("Please enter valid date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					return;
				}
				payload["med_case"] = false;
				payload["is_dispose"] = true;
				payload["stock_notes"] = this.batchList[i].stock_notes || "dispose";
			}
			payload["log_date"] = this.apiService.getDateStringFromDate(this.batchList[i].log_date, "YYYY-MM-DD");
		}
		this.showBatchSaveLoader = i;
		this.apiService.consumptionLogTracking(payload).subscribe({
			next: (data: any) => {
				this.showBatchSaveLoader = null;
				this.batchList[i].batch_qty_original = this.batchList[i].batch_qty;
				this.toastr.success("Saved successfully", 'Success', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				this.refreshTableMed();
				this.refreshTableEquip();
				this.refreshTableDisp();
				$("#batchDetailsModalDash").modal("hide");
				this.clearBatchModal();
			}, error: (error) => {
				this.showBatchSaveLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	addBatchQty(i: number) {
		if (this.batchList[i].batch_qty_original == this.batchList[i].batch_qty) {
			this.toastr.error("Nothing to change", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (isNaN(this.batchList[i].batch_qty) || parseFloat(this.batchList[i].batch_qty) <= 0) {
			this.toastr.error("Please enter valid quantity", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		let cons_qty: any;
		if (this.batchList[i].batch_qty_original > this.batchList[i].batch_qty) {
			cons_qty = this.batchList[i].batch_qty_original - this.batchList[i].batch_qty;
		} else {
			cons_qty = this.batchList[i].batch_qty - this.batchList[i].batch_qty_original;
		}
		let cons_type: any;
		if (this.batchList[i].batch_qty_original > this.batchList[i].batch_qty) {
			cons_type = "Subtract";
			this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		} else {
			cons_type = "Add";
		}
		if (cons_type == "Add") {
			if (!this.batchList[i].BrandName) {
				this.toastr.error("Please enter brand name", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			}
			if (!this.batchList[i].BatchNo) {
				this.toastr.error("Please enter batch number", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			}
			if (!this.batchList[i].BatchExpDate) {
				this.toastr.error("Please enter batch expiry date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			}
			/* if (this.batchList[i].BatchExpDate && isBefore(new Date(), this.batchList[i].BatchExpDate)) {
				this.toastr.error("Please enter valid date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			} */
		}
		let payload: any = {
			line_id: this.batchList[i].line_id,
			BrandName: this.batchList[i].BrandName,
			BatchNo: this.batchList[i].BatchNo,
			BatchExpDate: this.apiService.getDateStringFromDate(this.batchList[i].BatchExpDate, "YYYY-MM-DD"),
			BatchAvalQty: cons_qty
		}
		this.showBatchSaveLoader = i;
		this.apiService.addInventoryBatch(payload).subscribe({
			next: (data: any) => {
				this.showBatchSaveLoader = null;
				this.batchList[i].batch_qty_original = this.batchList[i].batch_qty;
				this.toastr.success("Saved successfully", 'Success', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				this.refreshTableMed();
				this.refreshTableEquip();
				this.refreshTableDisp();
				$("#batchDetailsModalDash").modal("hide");
				this.clearBatchModal();
			}, error: (error) => {
				this.showBatchSaveLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}
}
